import nl from './nl';

const messages = {
    nl,
}

export default messages;
